<template>
  <div>
    <span 
      v-if="type=='button'"
    >
      <v-icon
        color="blue darken-2"
        :dark="document.estatus.descripcion !== 'Firmado' && document.estatus.descripcion !== 'Cancelado'"
        :disabled="document.estatus.descripcion === 'Firmado' || document.estatus.descripcion === 'Cancelado'"
        @click="dialog = true"
        >{{ 
          document.estatus.descripcion === 'Pendiente' ? icon.trash : icon.cancel 
        }}</v-icon
      >
    </span>
    <v-list-item
      v-else-if="type=='list'"
      :disabled="document.estatus.descripcion === 'Firmado' || document.estatus.descripcion === 'Cancelado'"
      @click.stop="onClick"
    >
      <v-list-item-title>{{document.estatus.descripcion === 'Pendiente' || document.estatus.descripcion === 'Expirado' ? 'Eliminar' : 'Cancelar'}}</v-list-item-title>
    </v-list-item>

    <v-dialog v-model="dialog" persistent max-width="550">
      <v-card>
        <v-card-title class="headline">{{
          document.estatus.descripcion === 'Pendiente' || document.estatus.descripcion === 'Expirado' ? 
          documentDeleteLabels.questionDeleteText : documentDeleteLabels.questionCancelText
        }}</v-card-title>
        <v-card-text>{{ 
          document.estatus.descripcion === 'Pendiente' || document.estatus.descripcion === 'Expirado' ?  
          documentDeleteLabels.descriptionDeleteText : documentDeleteLabels.descriptionCancelText
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="document_firmante__eliminar__btn_si"
            color="accent"
            text
            @click="onDeleteDocument"
            :loading="loading"
            >{{ documentDeleteLabels.positiveButtonText }}</v-btn
          >
          <v-btn
            id="document_firmante__eliminar__btn_no"
            color="red darken-1"
            text
            @click="dialog = false"
            :disabled="loading"
            >{{ documentDeleteLabels.negativeButtonText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiTrashCanOutline, mdiMinusCircleOutline } from '@mdi/js'
import { documentsData, documentsActions } from '../store/documentsHelpers'
import signersService from '@/modules/signers/services/SignerService'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

export default {
  name: 'DocumentDelete',
  props: {
    document: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  data() {
    return {
      icon: {
        trash: mdiTrashCanOutline,
        cancel: mdiMinusCircleOutline
      },
      loading: false,
      dialog: false
    }
  },
  computed: {
    ...documentsData
  },
  methods: {
    ...documentsActions,
    onClick(){
      this.dialog = true
      this.$emit('click')
    },
    onDeleteDocument() {
      this.loading = true
      
      this.deleteDocument(this.document.idDocumento)
        .then(result => {
          pushNotification(
            this.$store,
            result.data.successful.message,
            'info',
            'left',
            false,
            false
          )
          
          if (result.data.successful.code == 'DOCUMENT-DELETE-201') {
            let service = new signersService()
            service.notifySigners({
              idDocumento: this.document.idDocumento,
              tipoNotificacion: 5
            })
          }
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
          this.dialog = false
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgDocumentServiceError,
        'error',
        'left',
        false,
        false
      )
    }
  }
}
</script>
